var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4v2m0 2h.005M11 6A5 5 0 111 6a5 5 0 0110 0z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgNC4wMDAyNFY2LjAwMDI0TTYgOC4wMDAyNEg2LjAwNU0xMSA2LjAwMDI0QzExIDguNzYxNjcgOC43NjE0MiAxMS4wMDAyIDYgMTEuMDAwMkMzLjIzODU4IDExLjAwMDIgMSA4Ljc2MTY3IDEgNi4wMDAyNEMxIDMuMjM4ODIgMy4yMzg1OCAxLjAwMDI0IDYgMS4wMDAyNEM4Ljc2MTQyIDEuMDAwMjQgMTEgMy4yMzg4MiAxMSA2LjAwMDI0WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgAlertCircle as ReactComponent };